package music.jammers.client.shared.component.track.presentation.model

import music.jammers.shared.event.domain.model.EventMember
import music.jammers.shared.event.track.domain.model.EventTrack

data class TrackCardModel(
    val eventTrack: EventTrack,
    val availableMembers: List<EventMember>,
    val isMyTrack: Boolean,
)
